/* One wrapper width and gutter for every narrative section, so the left edge
   of a heading in the hero sits on the same column as the left edge of a
   heading six sections down. */
export const WRAP = "mx-auto max-w-[1400px] px-5 md:px-8";
